// Initialize Firebase core app
import { initializeApp } from "firebase/app";
// Import the services you need
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics"; // If you need Analytics

// Your Firebase project configuration (from Firebase Project settings)
const firebaseConfig = {
 apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

console.log("RUNTIME Firebase Config AuthDomain:", firebaseConfig.authDomain);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services and get references to them
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app); // If you're using Analytics

// What you should export:
export { db, auth, analytics }; // Export the services you want to use elsewhere
